export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 3a1 1 0 011 1v.5a2 2 0 104 0V4a1 1 0 011-1h5a1 1 0 011 1v4.535a3.501 3.501 0 010 6.929V20a1 1 0 01-1 1h-5a1 1 0 01-1-1v-.5a2 2 0 00-4 0v.5a1 1 0 01-1 1H4a1 1 0 01-1-1v-4.536a3.5 3.5 0 010-6.929V4l.005-.103A1 1 0 014 3h5zM5 9.5a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3H4a1 1 0 011 1V19h3.032a4 4 0 017.936 0H19v-4.5a1 1 0 011-1h.5a1.5 1.5 0 000-3H20a1 1 0 01-1-1V5h-3.032a4 4 0 01-7.936 0H5v4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};